import { cn } from "@/lib/utils.ts";
import { SdgGoalResult } from "@/schema/assessment-results/SdgGoalResult";
import { TargetArrow24Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

interface SDGGroupListProps {
  sdgGoalResult: SdgGoalResult;
}
export default function SDGGroupList({
  sdgGoalResult: { sdg_goal_id, name, sdg_target_results },
}: SDGGroupListProps) {
  const { t } = useTranslation();

  return (
    <div>
      <div className="bg-cool-gray-100 flex flex-row items-center gap-x-[12px] px-[12px] py-[8px]  border-t-[1px] border-cool-gray-200">
        <TargetArrow24Regular />
        <span className="text-cool-gray-900 text-[14px] font-medium">
          {name}
        </span>
        <span className="text-cool-gray-500 text-[12px] font-medium ml-auto">
          {sdg_target_results.length} {t("target")}
          {sdg_target_results.length > 1 ? "s" : ""}
        </span>
      </div>
      {sdg_target_results.map((item, index) => {
        return (
          <div key={index} className="grid grid-cols-[max-content,1fr]">
            <div className="pl-[24px] overflow-hidden">
              <div className="w-[20px] h-[40%] bg-[transparent] border-l-[2px] border-b-[2px] rounded-bl-[16px] border-[#E3E4E5]" />
              {index != sdg_target_results.length - 1 && (
                <div className="w-[20px] h-[100%] bg-[transparent] border-l-[2px] border-[#E3E4E5] mt-[-60%]" />
              )}
            </div>

            <div
              className={cn(
                "grid grid-cols-[repeat(2,max-content),1fr]  border-[#E3E4E5]",
                index != sdg_target_results.length - 1 && "border-b-[1px]",
              )}
            >
              <div className="py-[16px] px-[24px]">
                <span className="text-cool-gray-700 text-[14px] leading-[20px] font-medium">
                  {t("target")} {sdg_goal_id}.{item.target_number}
                </span>
              </div>
              <div className="py-[16px] px-[24px]">
                <div>
                  <span className="text-cool-gray-500 text-[14px] leading-[20px] font-normal">
                    {t("attainment")}
                  </span>
                </div>
                <div className="flex justify-center">
                  <span className="text-cool-gray-700 text-[14px] leading-[20px] font-bold">
                    {item.score ?? "--"}%
                  </span>
                </div>
              </div>
              <div className="py-[16px] px-[24px]">
                <span className="text-cool-gray-700 text-[14px] leading-[20px] font-medium font-sans">
                  {item.evaluation_note}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
